import { useState } from "react";

// A treat's picture, falling back to its first letter (or a legacy emoji) if
// the image is missing or fails to load — never a broken-image icon.
function TreatImage({ image, name, icon, size = 56 }) {
  const [failed, setFailed] = useState(false);
  const style = { width: size, height: size };

  if (image && !failed) {
    return <img src={image} alt={name} className="treat-img" style={style} onError={() => setFailed(true)} />;
  }
  return (
    <span className="treat-img treat-img-fallback" style={{ ...style, fontSize: size * 0.5 }} aria-label={name}>
      {icon || (name || "?").charAt(0).toUpperCase()}
    </span>
  );
}

export default TreatImage;
